export default __webpack_public_path__ + "static/media/tvinsure-pattern-05.fc8b7bac.png";